const messageList = {
    path: 'list',
    component: resolve => require(['@/pages/admin/message/list.vue'], resolve)
}

export default messageList